<template>
  <section>
    <div class="col-sm-12 col-md-12 form-group pt-3 mt-4">
      <h4 class="text-white mb-2 text-center">Sua senha foi salva com sucesso!</h4>

      <div class="col-sm-12 col-md-12 form-group mt-4 mb-4 pt-2">
        <button
          class="btn btn-block shadow-sm btnStock btn"
          :style="secondaryBtnStyle"
          @click="$router.push(goToHomePage)"
        >
          <i class="fa fa-caret-left"></i>
          Voltar para o login
        </button>
      </div>
    </div>
  </section>
</template>

<script>
/* State */
import { mapState, mapGetters } from 'vuex'
import { getSSORedirectUrl } from '@/helpers/ssoHelper'

export default {
  name: 'Completo',
  computed: {
    ...mapGetters(['secondaryBtnStyle']),
    ...mapState(['template', 'config', 'subdomain']),
    goToHomePage() {
      return getSSORedirectUrl(this.config)
    },
  },
}
</script>
